import { FC } from 'react'
import { usePaymentRedirect } from './use-payment-redirect'

export const PaymentRedirect: FC = () => {
  usePaymentRedirect()

  return <div id="root-payment-redirect" />
}
